const useCuestionarioStore = defineStore("cuestionario", () => {
  const cuestionario = ref({
    id: null,
    nombre: "",
    descripcion: "",
    prioritario: true,
    perteneciente: 1, // 1: Tipo de Biografía, 2: Sección de tipo de Biografía, 3:Sistema, 4: Invitación, 5: Regalo
    tipoBiografias: [],
    seccions: [],
    unico: false,
    despacho: 1, // 1: al ingresar al sistema, 2 : al regalar un producto...
  });

  const cuestionarios = ref([]);

  const draft = computed(() => {
    return clone(cuestionario.value);
  });

  const pertenecienteOptions = computed(() => [
    { value: 1, text: "Tipo de Biografía" },
    { value: 2, text: "Sección de Tipo de Biografía" },
    { value: 3, text: "Sistema" },
    { value: 4, text: "Invitación" },
    { value: 5, text: "Regalo" },
  ]);

  const setCuestionario = (payload) => {
    cuestionario.value = payload;
  };

  const setCuestionarios = (payload) => {
    cuestionarios.value = payload;
  };

  const clear = () => {
    cuestionario.value = {
      id: null,
      nombre: "",
      descripcion: "",
      prioritario: true,
      perteneciente: 1, // 1: Tipo de Biografia, 2: seccion de tipo de biografia
      tipoBiografias: [],
      seccions: [],
      unico: false,
      despacho: 1, // 1: al ingresar al sistema.
    };
  };

  // actions
  const fetch = (cuestionario_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/cuestionarios/${cuestionario_id}/fetch-data`)
        .then(({ data }) => {
          setCuestionario(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/cuestionarios/fetch-data`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .put(`/api/cuestionarios/${datos.id}`, datos)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      } else {
        axios
          .post(`/api/cuestionarios`, datos)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (cuestionario_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/cuestionarios/${cuestionario_id}`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchListSelectPerteneciente = (perteneciente) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/cuestionarios/list-select-perteneciente`, { perteneciente })
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchPreguntas = (cuestionario_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/cuestionarios/${cuestionario_id}/fetch-preguntas`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const addPregunta = ({ cuestionario_id, pregunta_id, new_index }) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/cuestionarios/${cuestionario_id}/add-pregunta`, {
          pregunta_id,
          new_index,
        })
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const removePregunta = ({ cuestionario_id, pregunta_id, old_index }) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/cuestionarios/${cuestionario_id}/remove-pregunta`, {
          pregunta_id,
          old_index,
        })
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const updateOrdenPregunta = (cuestionario_id, datos) => {
    // nuevo_orden: el nuevo orden de la pregunta en el cuestionario
    return new Promise((resolve, reject) => {
      axios
        .put(
          `/api/cuestionarios/${cuestionario_id}/update-orden-pregunta`,
          datos
        )
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  return {
    cuestionario,
    cuestionarios,
    draft,
    pertenecienteOptions,
    setCuestionarios,
    setCuestionario,
    clear,
    fetch,
    fetchData,
    guardar,
    eliminar,
    fetchListSelectPerteneciente,
    fetchPreguntas,
    addPregunta,
    removePregunta,
    updateOrdenPregunta,
  };
});

export default useCuestionarioStore;
